import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/store/auth";
import { loginUrlWithIntent, type Intent } from "@/lib/authIntent";

export function useRequireAuth() {
  const { status } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return (intent: Intent, action: () => void) => {
    if (status === "authenticated") {
      action();
      return;
    }
    navigate(loginUrlWithIntent(location.pathname, location.search, intent));
  };
}